import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button';
import { FaEdit, FaRedo, FaTrash } from 'react-icons/fa';
import ReactPaginate from 'react-paginate';
import Skeleton from 'react-loading-skeleton';
import UserLevelGrapgh from '../graphs/UserLevelGrapgh';

const skeletonStyle = {
    backgroundColor: '#f0f0f0', // Set the background color for the skeleton
    position: 'relative',
    overflow: 'hidden',
  };
  
  const highlighterStyle = {
    position: 'absolute',
    top: 0,
    left: '-100%', // Move the highlighter off-screen initially
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 160, 0.1)', // Set the highlighter color and transparency
    animation: 'highlight 5.5s infinite linear', // Add animation to create a sliding effect
  };

const UserLableAnalytics = () => {
    const [isLoading, setIsloading] = useState(true);
    const [issuccess, setsuccess] = useState(false);
    const [iserror, seterror] = useState(false);
    const [query, setQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPagelimit, setPageLimit] = useState(5);
    const [userType, setUsertype] = useState("");
    const [userGroup, setUserGroup] = useState(null);
    const [Deleteinguser, setDeleteinguser] = useState(false);
    const [userinfo, setuserinfo] = useState([]);

    const passtoken = JSON.parse(localStorage.getItem("access-token-storage"))[
        "accessToken"
      ]["accessToken"];
  

      
  const baseurl = `${process.env.REACT_APP_SERVER_URL}/aipd/getUserList `

  // const baseurl = `http://localhost:8082/aipd/user`

  useEffect(() => {
    fetchSearchByname();
  }, [baseurl,passtoken]);

  const fetchSearchByname = async () => {
    await fetch(`${baseurl}`, {
      headers: {
        "oidc-token": passtoken,
        "Accept":"application/json"
      },
    })
      .then((response) => {
        if (response.ok) {
          response.json().then((json) => {
            setuserinfo(json);
            setIsloading(false)
          //  console.log(isLoading);
          });
        }
      })
      .catch((err) => {
        setuserinfo(null);
        setIsloading(false)

      });
  };

  const sortedAsc = (userinfo === null ? '' :  userinfo.slice(0).sort((a,b)=>
  b.lastUpdateDateTime.localeCompare(a.lastUpdateDateTime)))

  const search_parameters = ['emailAddress'];
  const filter_by_userType = [...new Set(userinfo.map((item) => item.userType))];

  const userGroupIds = [...new Set(userinfo.map((item) => item.userGroup.map((group) => group.userGroupId)))];

  const userGroupName1 = [...new Set(userGroupIds)]
  const resultArray1 = [].concat(...userGroupName1);
  const resultArray = [...resultArray1.flat()];
  const userGroupName = [...new Set(resultArray)]
  userGroupName.sort((a, b) => a - b);

  let filteredData = [];

  filteredData = sortedAsc.filter((obj) => {
    return obj;
  });

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  function search(sortedAsc) {
    return filteredData.filter((item) =>
      item.userType.includes(userType) &&
      (!userGroup || item.userGroup.some((group) => group.userGroupId === parseInt(userGroup))) &&
      search_parameters.some((parameter) =>
        item[parameter].toString().toLowerCase().includes(query.toLowerCase())
      )
    );
  }

  const currentData = search(filteredData).slice(
    (currentPage - 1) * currentPagelimit,
    (currentPage - 1) * currentPagelimit + currentPagelimit
  );

  const pageCount = Math.ceil(search(filteredData).length / currentPagelimit);

  const handelepageclick = (data) => {
    setCurrentPage(data.selected + 1);
  };
      
  
  return (
    <div>
      {isLoading && (
        <table id="Create_users_id" style={{ width: "100%" }}>
          <tbody>
            <tr>
              <th
                style={{
                  background: "#d0d8e2",
                  color: "#253978",
                  width: "29%",
                }}
              >
                Email
              </th>

              <th
                style={{
                  background: "#d0d8e2",
                  color: "#253978",
                  width: "20%",
                }}
              >
                Assigned By
              </th>

              <th
                style={{
                  textAlign: "center",
                  background: "#d0d8e2",
                  color: "#253978",
                  width: "8%",
                }}
              >
                User Type
              </th>
             
             
             
              <th
                className="notinPrint"
                style={{
                  textAlign: "center",
                  background: "#d0d8e2",
                  color: "#253978",
                  width: "5%",
                }}
              ></th>
            </tr>

            {Array.from({ length: 6 }, (_, i) => (
              <tr key={i}>
                <td>
                  <div style={skeletonStyle}>
                    <Skeleton height={20} />
                    <div style={highlighterStyle}></div>
                  </div>
                </td>
                <td>
                  <div style={skeletonStyle}>
                    <Skeleton height={20} />
                    <div style={highlighterStyle}></div>
                  </div>
                </td>
                <td>
                  <div style={skeletonStyle}>
                    <Skeleton height={20} />
                    <div style={highlighterStyle}></div>
                  </div>
                </td>
                <td>
                  <div style={skeletonStyle}>
                    <Skeleton height={20} />
                    <div style={highlighterStyle}></div>
                  </div>
                </td>
             
               
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {!isLoading && (
        <div id="Create_users_id" className='analyticsTable'>
          <div className="wrapper">
            <div
              style={{ paddingBottom: "0rem" }}
              className="searchBarSections"
            >
             

              <div
                style={{
                  display: "flex",
                  gridGap: "10px",
                  alignContent: "center",
                  alignItems: "center",
                  position: "absolute",
                  right: "30px",
                  top: "30px",
                }}
              ></div>
            </div>

            <div
              style={{
                display: "flex",
                paddingBottom: "0rem",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gridGap: "10px",
              }}
            >
              {/* <div style={{ width: "30%" }} className="search-wrapper">
                <input
                  type="search"
                  name="search-form"
                  id="search-form"
                  autoComplete="off"
                  value={query}
                  className="SearchBox_new"
                  placeholder="Search for Email, Assigned By"
                  onChange={(e) => {
                    setQuery(e.target.value);
                    handlePageChange({ selected: 1 });
                  }}
                />
              </div> */}

              <div style={{ display: "none", gridGap: "20px" }}>
                <div className="selectParent select">
                  <select
                    value={userType}
                    onChange={(e) => {
                      setUsertype(e.target.value);
                      handlePageChange({ selected: 1 });
                    }}
                    className="custom-select"
                    aria-label="Filter user type"
                  >
                    <option value="">Filter by User Type</option>
                    {filter_by_userType.map((item, index) => (
                      <option key={index} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                  <span className="focus"></span>
                </div>

                <div className="selectParent select">
                  <select
                    value={userGroup}
                    onChange={(e) => {
                      setUserGroup(e.target.value);
                      handlePageChange({ selected: 1 });
                    }}
                    className="custom-select"
                    aria-label="Filter by user group"
                  >
                    <option value="">Filter by User Group</option>
                    {userGroupName.map((item, index) => (
                      <option key={index} value={item}>
                        {item === 104
                          ? "Dealer"
                          : item === 102
                          ? "Field"
                          : item === 103
                          ? "Headquarter"
                          : item === 101
                          ? "Admin"
                         
                          : ""}
                      </option>
                    ))}
                  </select>
                  <span className="focus"></span>
                </div>

                <div>
                  <Button
                    title="Reset all filters"
                    style={{
                      borderRadius: "6px",
                      textTransform: "capitalize",
                      fontSize: "16px",
                      display: "flex",
                      gridGap: "10px",
                      alignContent: "center",
                      alignItems: "center",
                      background: "#0000a0",
                      padding: "8px",
                      color: "white",
                      fontWeight: "600",
                      width: "auto",
                    }}
                    className="submit_btn"
                  >
                    <FaRedo />
                  </Button>
                </div>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingBottom: "1rem",
                paddingTop: "1rem",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gridGap: "10px",
                  alignContent: "center",
                  alignItems: "center",
                  width:"30%"
                }}
              >
                <div style={{ width: "100%" }} className="search-wrapper">
                <input
                  type="search"
                  name="search-form"
                  id="search-form"
                  autoComplete="off"
                  value={query}
                  className="SearchBox_new"
                  placeholder="Search for Email"
                  onChange={(e) => {
                    setQuery(e.target.value);
                    handlePageChange({ selected: 1 });
                  }}
                />
              </div>
              </div>

              <div
                style={{
                  display: "flex",
                  gridGap: "10px",
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                <div>
                  <ReactPaginate
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={handelepageclick}
                    containerClassName={"pagination"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                    activeClassName={"active"}
                    forcePage={currentPage - 1}
                  />
                </div>
              </div>
            </div>

            {isLoading && (
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <th
                      style={{
                        background: "#d0d8e2",
                        color: "#253978",
                        width: "29%",
                      }}
                    >
                      Email
                    </th>

                    <th
                      style={{
                        background: "#d0d8e2",
                        color: "#253978",
                        width: "20%",
                      }}
                    >
                      Assigned By
                    </th>

                  
                    <th
                      style={{
                        textAlign: "center",
                        background: "#d0d8e2",
                        color: "#253978",
                        width: "10%",
                      }}
                    >
                      User Type
                    </th>
                  
                    <th
                      className="notinPrint"
                      style={{
                        textAlign: "center",
                        background: "#d0d8e2",
                        color: "#253978",
                        width: "5%",
                      }}
                    ></th>
                  
                  </tr>

                  {Array.from({ length: 6 }, (_, i) => (
                    <tr key={i}>
                      <td>
                        <div style={skeletonStyle}>
                          <Skeleton height={20} />
                          <div style={highlighterStyle}></div>
                        </div>
                      </td>
                      <td>
                        <div style={skeletonStyle}>
                          <Skeleton height={20} />
                          <div style={highlighterStyle}></div>
                        </div>
                      </td>
                     
                      <td>
                        <div style={skeletonStyle}>
                          <Skeleton height={20} />
                          <div style={highlighterStyle}></div>
                        </div>
                      </td>
                      <td>
                        <div style={skeletonStyle}>
                          <Skeleton height={20} />
                          <div style={highlighterStyle}></div>
                        </div>
                      </td>
                      <td>
                        <div style={skeletonStyle}>
                          <Skeleton height={20} />
                          <div style={highlighterStyle}></div>
                        </div>
                      </td>
                      
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            {!isLoading && (
              <table id="DataTable" style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <th
                      style={{
                        background: "#d0d8e2",
                        color: "#253978",
                        width: "17%",
                      }}
                    >
                      Email
                    </th>

                    <th
                      style={{
                        background: "#d0d8e2",
                        color: "#253978",
                        width: "17%",
                      }}
                    >
                      Assigned By
                    </th>

                    <th
                      style={{
                        textAlign: "center",
                        background: "#d0d8e2",
                        color: "#253978",
                        width: "10%",
                      }}
                    >
                      User Type
                    </th>
                  
                   
                    <th
                      className="notinPrint"
                      style={{
                        textAlign: "center",
                        background: "#d0d8e2",
                        color: "#253978",
                        width: "2%",
                      }}
                    ></th>
                   
                  </tr>

                  {search(filteredData).length !== 0 && (
                    <>
                      {currentData.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <div
                              title={item.emailAddress}
                              style={{
                                display: "grid",
                                justifyContent: "start",
                                fontWeight: "500",
                              }}
                            >
                              <span className="user_items_cls items_cls font-size-new">
                                {item.emailAddress}
                              </span>
                            </div>
                          </td>

                          

                          <td style={{ fontWeight: "normal" }}>
                            <span
                              style={{
                                display: "grid",
                                justifyContent: "start",
                              }}
                              title={item.createdBy}
                            >
                              <span className="user_items_cls items_cls font-size-new">
                                {item.createdBy}
                              </span>
                            </span>
                          </td>

                          <td style={{ fontWeight: "normal" }}>
                            <span
                              style={{
                                display: "grid",
                                justifyContent: "center",
                              }}
                            >
                              <span className="user_items_cls items_cls font-size-new">
                                {item.userType}
                              </span>
                            </span>
                          </td>

                        
                         

                          <td
                            className="notinPrint"
                            style={{ fontWeight: "normal" }}
                          >
                            <span
                              style={{
                                display: "grid",
                                justifyContent: "center",
                                cursor: "pointer",
                              }}
                              //   onClick={(e) =>
                              //     getUserDetail(
                              //       item.emailAddress,
                              //       item.userGroup,
                              //       item.userType,
                              //       item.rlType
                              //     )
                              //   }
                            >
                                <UserLevelGrapgh email ={item.emailAddress}/>
                            </span>
                          </td>

                       
                        </tr>
                      ))}
                    </>
                  )}

                  {search(filteredData).length === 0 && (
                    <tr style={{ textAlign: "center" }}>
                      <td
                        style={{ textAlign: "center", color: "red" }}
                        rowSpan={4}
                        colSpan={9}
                      >
                        No users available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default UserLableAnalytics
